module.exports = __webpack_public_path__ + "media/plans/medium-7e584efa.png";